// Pairs events (Paul, 31 Oct 2026): /events - what's coming up and what just ran. Neutral labels.
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { ph, testUid } from "../PartnerHub/phApi";
import { fmtWhen, FORMAT_LABEL, SCORING_LABEL } from "./eventFeed";
import "../PartnerHub/PartnerHub.css";
import "./Events.css";

const BADGE = { open: ["Entries open", "ev-badge--open"], seating: ["Starting", "ev-badge--live"], playing: ["In play", "ev-badge--live"], finished: ["Finished", "ev-badge--done"], cancelled: ["Didn't run", "ev-badge--done"] };

function EventsList({ uid, authReady }) {
  const signedIn = !!uid || !!testUid();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!signedIn) return undefined;
    let alive = true;
    const load = () => ph("evList").then((d) => { if (alive) { setData(d); setErr(""); } }).catch((e) => alive && setErr(e.message));
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 20000);
    return () => { alive = false; clearInterval(t); };
  }, [signedIn]);

  if (!authReady && !testUid()) return <div className="pth-root"><div className="pth-page"><p className="pth-muted">Loading…</p></div></div>;
  if (!signedIn) {
    return (
      <div className="pth-root">
        <Helmet><title>Events — Bridge Champions</title><meta name="robots" content="noindex" /></Helmet>
        <div className="pth-page pth-narrow"><div className="pth-card pth-center">
          <h1 className="pth-h1">Events</h1>
          <p className="pth-muted">Sign in to see the events.</p>
          <div className="pth-actions pth-actions--center">
            <Link className="pth-btn pth-btn--primary" to="/login">Sign in</Link>
            <Link className="pth-btn pth-btn--ghost" to="/signup">Create a free account</Link>
          </div>
        </div></div>
      </div>
    );
  }
  return (
    <div className="pth-root">
      <Helmet><title>Events — Bridge Champions</title><meta name="robots" content="noindex" /></Helmet>
      <div className="pth-page pth-narrow">
        <Link className="pth-backText" to="/partner">← Partners</Link>
        <h1 className="pth-h1">Events</h1>
        <p className="pth-muted pth-lead">Pairs events played live against other pairs.</p>
        {err && <section className="pth-card pth-center"><p className="pth-muted">{err}</p><Link className="pth-btn pth-btn--ghost" to="/partner">Back to partners</Link></section>}
        {err ? null : !data ? <div className="pth-skeleton" aria-label="Loading" /> : !data.events.length ? (
          <section className="pth-card pth-center"><p className="pth-muted">No events are scheduled.</p></section>
        ) : (
          <div className="ev-list">
            {data.events.map((e) => {
              const [label, cls] = BADGE[e.status] || [e.status, ""];
              const d = new Date(e.startsAt);
              return (
                <Link key={e.id} className="pth-card ev-item" to={`/events/${e.id}`}>
                  <span className="ev-when">{d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" })}<small>{d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}</small></span>
                  <span className="ev-itemTxt">
                    <b>{e.name}</b>
                    <span>{FORMAT_LABEL[e.format] || e.format} · {SCORING_LABEL[e.scoring] || e.scoring} · {e.rounds} × {e.boardsPerRound} boards · {e.pairCount || 0} pairs{e.myPair ? " · you're entered" : ""}</span>
                  </span>
                  <span className={`ev-badge ${cls}`}>{label}</span>
                </Link>
              );
            })}
          </div>
        )}
        <p className="pth-note">{fmtWhen(Date.now()) ? "Times are shown in your own time zone." : ""}</p>
      </div>
    </div>
  );
}

export default connect((state) => ({ uid: state.auth?.uid, authReady: state.auth?.authReady === true }))(EventsList);
